import EditarGrupo from 'containers/Admin/EditarGrupo'

export default function CrearGrupo() {
  return (
    <EditarGrupo />
  );
}